import React, { useState, useEffect } from "react";
import { CTA_URL, LANDING_COPY } from "../constants";

const StickyMobileCta: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { finalCta } = LANDING_COPY;

  useEffect(() => {
    const heroSection = document.getElementById("inicio");

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: "-100px 0px 0px 0px",
      },
    );

    if (heroSection) {
      observer.observe(heroSection);
    }

    return () => {
      if (heroSection) {
        observer.unobserve(heroSection);
      }
    };
  }, []);

  if (typeof window !== "undefined" && window.innerWidth >= 768) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 md:hidden transition-all duration-300 ${
        isVisible
          ? "translate-y-0 opacity-100"
          : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="bg-surface/95 backdrop-blur-md border-t border-border-strong px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]">
        <a
          href={CTA_URL}
          className="flex items-center justify-center gap-2 w-full bg-accent hover:bg-accent-dark text-text-primary py-3.5 font-semibold uppercase tracking-wide text-sm btn-press"
        >
          {finalCta.button}
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCta;
